import { render, staticRenderFns } from "./Rec.vue?vue&type=template&id=984d17c8"
import script from "./Rec.vue?vue&type=script&lang=js"
export * from "./Rec.vue?vue&type=script&lang=js"
import style0 from "./Rec.vue?vue&type=style&index=0&id=984d17c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports